/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const KeyAdoptionStrategy = core.serialization.enum_(["exact", "contains", "jaccard"]);
